<template>
<v-layout row justify-center align-center>
  <v-flex xs12 sm4>
    <v-card>
        <v-toolbar card dark color="primary">
            <v-toolbar-title>내정보</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form>
                <v-text-field prepend-icon="email" name="email" label="email" type="text" v-model="email" disabled></v-text-field>
                <v-text-field prepend-icon="face" name="name" label="name" type="text" v-model="displayName" required></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="passwordDialog = true">비밀번호 변경</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="$_updateProfile()">수정</v-btn>
        </v-card-actions>
    </v-card>
  </v-flex>

  <v-dialog v-model="passwordDialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">비밀번호 변경</span>
      </v-card-title>

      <v-card-text>
        <v-form xs12
          ref="passwordForm"
          v-model="passwordFormValid"
          lazy-validation>
          <v-flex xs12>
            <v-text-field
              label="현재 비밀번호"
              type="password"
              ref="currentPassword"
              name="currentPassword"
              v-model="currentPassword"
              autocomplete="current-password"
              :rules="passwordRules"
              :error-messages="currentPasswordErrorMessage"
              @input="currentPasswordErrorMessage = ''"
              required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="새로운 비밀번호"
              type="password"
              ref="newPassword"
              name="newPassword"
              v-model="newPassword"
              autocomplete="new-password"
              :rules="newPasswordRules"
              :error-messages="newPasswordErrorMessage"
              @input="newPasswordErrorMessage = ''"
              required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="비밀번호 재확인"
              type="password"
              ref="newPasswordConfirm"
              name="newPasswordConfirm"
              v-model="newPasswordConfirm"
              autocomplete="new-password"
              :rules="confirmPasswordRules"
              :error-messages="confirmPasswordErrorMessage"
              @input="confirmPasswordErrorMessage = ''"
              required></v-text-field>
          </v-flex>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$_closePasswordDialog">취소</v-btn>
        <v-btn color="blue darken-1" flat @click="$_passwordChange">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

export default {
  name: 'Profile',
  data () {
    return {
      displayName: '',
      email: '',
      snackbar: {
        on: false,
        text: '',
        timeout: 2000
      },
      passwordDialog: false,
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      passwordFormValid: false,
      passwordRules: [
        v => !!v || '비밀번호를 입력하세요.',
        v => (v && v.length >= 6) || '비밀번호는 6자 이상입니다.'
      ],
      newPasswordRules: [
        v => !!v || '비밀번호를 입력하세요.',
        v => (v && v.length >= 6) || '비밀번호는 6자 이상입니다.',
        v => (v && v !== this.currentPassword) || '현재 비밀번호와 다른 새로운 비밀번호를 입력하세요.'
      ],
      confirmPasswordRules: [
        v => (v && v === this.newPassword) || '비밀번호가 일치하지 않습니다.'
      ],
      currentPasswordErrorMessage: '',
      newPasswordErrorMessage: '',
      confirmPasswordErrorMessage: ''
    }
  },
  created () {
    this.$_getUserInfo()
  },
  watch: {
    passwordDialog (val) {
      val || this.$_closePasswordDialog()
    }
  },
  methods: {
    $_getUserInfo () {
      var user = firebase.auth().currentUser

      if (user != null) {
        this.displayName = user.displayName
        this.email = user.email
        // photoUrl = user.photoURL
        // emailVerified = user.emailVerified
        // uid = user.uid  // The user's ID, unique to the Firebase project. Do NOT use
        // this value to authenticate with your backend server, if
        // you have one. Use User.getToken() instead.

        // console.log(this.displayName, this.email, photoUrl, uid, emailVerified)
      }
    },
    $_openPasswrodDialog () {
      this.currentPassword = ''
      this.newPassword = ''
      this.newPasswordConfirm = ''
      this.currentPasswordErrorMessage = ''
      this.newPasswordErrorMessage = ''
      this.confirmPasswordErrorMessage = ''
      this.passwordDialog = true
      this.$refs.passwordForm.resetValidation()
    },
    $_closePasswordDialog () {
      this.passwordDialog = false
      setTimeout(() => {
        this.currentPassword = ''
        this.newPassword = ''
        this.newPasswordConfirm = ''
        this.currentPasswordErrorMessage = ''
        this.newPasswordErrorMessage = ''
        this.confirmPasswordErrorMessage = ''
        this.$refs.passwordForm.resetValidation()
      }, 300)
    },
    $_passwordChange () {
      // console.log(this.newPassword, this.newPasswordConfirm)
      if (this.$refs.passwordForm.validate()) {
        this.$refs.passwordForm.resetValidation()

        var user = firebase.auth().currentUser
        var cred = firebase.auth.EmailAuthProvider.credential(user.email, this.currentPassword)

        user.reauthenticateWithCredential(cred).then(() => {
          user.updatePassword(this.newPassword).then(() => {
            this.$emit('snackbar', '비밀번호를 변경하였습니다.')

            this.passwordDialog = false
          }).catch((error) => {
            this.$emit('snackbar', '비밀번호 변경에 실패하였습니다. 다시 시도해 주세요.')
            console.log(error)
          })
        }).catch(error => {
          if (error.code === 'auth/wrong-password') {
            // this.$refs.currentPassword.validate(false)
            this.currentPasswordErrorMessage = '현재 비밀번호를 다시 확인하세요.'
          } else {
            this.$emit('snackbar', '비밀번호 변경에 실패하였습니다. 다시 시도해 주세요.')
          }

          // console.log(error)
        })
      }
    },
    $_updateProfile () {
      var user = firebase.auth().currentUser

      user.updateProfile({
        displayName: this.displayName
      }).then(() => {
        this.$emit('snackbar', '수정 되었습니다.')
      }).catch((error) => {
        if (error) {
          this.$emit('snackbar', '수정에 실패하였습니다. 다시 시도해 주세요.')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue